module.exports = __webpack_public_path__ + "static/media/logo107.f552ab9b.png";